// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "TenurePickerPrompt" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { TenureOptionGenShape } from "./tenure-option.gen";

export const TenurePickerPromptGenShape = z.strictObject({
  prompt: z.string(),
  options: z.array(TenureOptionGenShape),
});
